import { render, staticRenderFns } from "./CustomerEditions.vue?vue&type=template&id=aaa96b60&"
import script from "./CustomerEditions.vue?vue&type=script&lang=js&"
export * from "./CustomerEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports